/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Routine_SavedInputs */

const en_us2_profile_editors_routine_saved = /** @type {(inputs: Profile_Editors_Routine_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine updated`)
};

const pt_br2_profile_editors_routine_saved = /** @type {(inputs: Profile_Editors_Routine_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina atualizada`)
};

const es_419_profile_editors_routine_saved = /** @type {(inputs: Profile_Editors_Routine_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutina actualizada`)
};

const pt_pt2_profile_editors_routine_saved = /** @type {(inputs: Profile_Editors_Routine_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina atualizada`)
};

const fr_fr2_profile_editors_routine_saved = /** @type {(inputs: Profile_Editors_Routine_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rythme mis à jour`)
};

const de_de2_profile_editors_routine_saved = /** @type {(inputs: Profile_Editors_Routine_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine aktualisiert`)
};

const it_it2_profile_editors_routine_saved = /** @type {(inputs: Profile_Editors_Routine_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine aggiornata`)
};

/**
* | output |
* | --- |
* | "Routine updated" |
*
* @param {Profile_Editors_Routine_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_routine_saved = /** @type {((inputs?: Profile_Editors_Routine_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Routine_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_routine_saved(inputs)
	if (locale === "es-419") return es_419_profile_editors_routine_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_routine_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_routine_saved(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_routine_saved(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_routine_saved(inputs)
	return en_us2_profile_editors_routine_saved(inputs)
});
export { profile_editors_routine_saved as "profile-editors.routine_saved" }